export interface CreateContactPayload {
  id: number;
  contactNaturalPersonEnterprise: ContactNaturalPersonEnterprise;
  contactTypeId: number;
  email: string;
  enterpriseAddress: EnterpriseAddress;
  enterpriseBankAccount: EnterpriseBankAccount;
  beneficiaryRelationshipId?: number;
}

export interface EnterpriseAddress {
  id?: number | undefined;
  name: string;
  city: string;
  state: string;
  addressLine1: string;
  addressLine2?: string;
  extNumber?: string;
  intNumber?: string;
  postCode: string;
}

export interface EnterpriseBankAccount {
  accountCurrency?: string;
  bankCountryCode?: string;
  routingNumber?: string;
  accountNumber: string;
  accountType?: string;
  bankName: string;
  clabe?: string;
  countryId: number;
  documentType?: string;
  identificationNumber?: string;
  id?: number | undefined;
  swiftCode: string;
  transferMethod?: number;
}

export interface ContactNaturalPersonEnterprise {
  enterprise: Enterprise;
  naturalPerson: NaturalPerson;
}

export interface Enterprise {
  country: string;
  entity_type: string;
  name: string;
  website?: string;
  countryId: number;
  rfc?: string;
}

export interface NaturalPerson {
  country: string;
  email: string;
  firstName: string;
  lastName: string;
  countryId: number;
  phoneNumber: string;
  documentType?: string;
  documentNumber?: string;
  uuid?: string;
}

export enum IBeneficiaryRelationshipId {
  SUPPLIER,
  CUSTOMER,
  CREDITOR,
  DEBTOR,
  PARENT_COMPANY,
  OTHER,
}
